/* global document */

import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { getCart } from 'redux/cart/actions';
import { getCollectionBySlug } from 'redux/collections/reducers';
import { listProducts } from 'redux/products/actions';

import Template from './components/ProductQuickShopTemplate';

class QuickShop extends Component {
  componentDidMount() {
    const { props } = this;
    this.listProducts();
    props.getCart();
  }

  listProducts = () => {
    const { props } = this;
    const { collectionSlug } = this.props;
    props.listProducts(collectionSlug, undefined, undefined, 'Quick Shop');
  };

  render() {
    const { settings, collection, products, cart } = this.props;
    if (!settings.data || !collection || !cart.data) {
      return null;
    }
    // Remove min-height after loaded
    const quickShopDOM = document.getElementById('c7-quick-shop');
    quickShopDOM.style.minHeight = 0;
    const productArray = collection.productIds.map((productId) => {
      const product = products.data[productId];
      return product;
    });
    return ReactDOM.createPortal(
      <>
        <Template
          products={productArray}
          settings={settings}
          cart={cart.data}
        />
      </>,
      quickShopDOM
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  collection: getCollectionBySlug(state.collection, ownProps.collectionSlug),
  products: state.product,
  settings: state.setting,
  cart: state.cart
});

export default connect(mapStateToProps, {
  listProducts,
  getCart
})(QuickShop);
